// extracted by mini-css-extract-plugin
export var legendIndicator = "_dw-1";
export var legendRight = "_dw-0";